/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaTipoSociedadVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaTipoSociedad: React.FunctionComponent<ITablaTipoSociedadVistaProps & InjectedIntlProps> = ({
    tipoSociedads,
    cargarTipoSociedad,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={tipoSociedads}
            actions={acciones(manejarFormulario, cargarTipoSociedad, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaTipoSociedad);
